<app-header [step]="2" (back)="onBack()"></app-header>

<div class="menu-container">
    <app-meal-list [isDemo]="true"></app-meal-list>
</div>
